import { useState } from 'react';
import Modal from '../Modal';
import { sizeData } from '../../data/sizeData';
import { useQuery, urlWithParams } from '../Util';
import { useNavigate } from 'react-router-dom';

export default function Size ({ setModal, setOutputWidth }) {
	const [customWidth, setCustomWidth] = useState('');

	const query = useQuery();
	const navigate = useNavigate();

	function updateWidth (newWidth) {
		setOutputWidth(newWidth);
		setModal('');

		if (newWidth !== query.get('preset')) {
			navigate(urlWithParams({
				preset: '',
				width: '',
				custom: '',
			}));
		}
	}

	function setWidthFromSize (e) {
		updateWidth(e.target.dataset.width);
	}

	function doSetCustomWidth (e) {
		setCustomWidth(e.target.value);
	}

	function doSaveCustomWidth () {
		updateWidth(customWidth);
	}

	return (
		<Modal setModal={setModal}>
			<h2>Pixel Width</h2>
			<div className="row">
				{sizeData.map(size => {
					return <div className="col-xs-12 col-md-6 col-lg-4 mb-3 d-flex align-items-stretch"
					            key={`modal-size-${size}`}
					>
						<div className="btn btn-outline-secondary w-100 flex-column pt-3 text-dark bg-primary-subtle"
						     onClick={setWidthFromSize}
						     data-width={size}
						>
							<h3 className="fs-4">{size}px</h3>
						</div>
					</div>;
				})}
				<div className="col-12 mx-auto text-center">
					<div className=" border p-3 col-10 rounded mx-auto">
						<label className="form-label" htmlFor="customWidth">Or enter a custom width:</label>

						<div className="input-group">
							<input type="number"
							       className="form-control fs-4"
							       onChange={doSetCustomWidth}
							       value={customWidth}
							       placeholder={'Enter a custom width'}
							       min="10"
							       step="1"
							/>
							<button type="button" className="btn btn-secondary"
							        onClick={doSaveCustomWidth}
							>
								Set it
							</button>
						</div>
					</div>
				</div>
			</div>

		</Modal>
	);
}